module.exports = __webpack_public_path__ + "71e9f9dc300bfdd57d3744f6eb8c8613.svg";